import { render, staticRenderFns } from "./activitiesTable.vue?vue&type=template&id=724cf087"
import script from "./activitiesTable.vue?vue&type=script&lang=js"
export * from "./activitiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports